var _defs, _path, _path2, _ellipse, _path3, _path4, _path5, _ellipse2, _path6, _path7, _circle, _circle2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _g2, _g3, _g4, _g5, _g6, _g7, _path15, _ellipse3, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _circle3, _path29, _path30, _path31, _path32, _ellipse4, _ellipse5, _path33, _ellipse6, _path34, _circle4, _circle5, _path35, _path36, _path37, _path38, _path39;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSeamlessImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "seamless-image_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 540 540"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "seamless-image_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-1",
    d: "M175.35 321.85l.61-23.36 21.5-3.47-.61 23.36-21.5 3.47z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "seamless-image_svg__clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-1",
    d: "M180.04 316.16l.34-13.45 12.39-2-.35 13.45-12.38 2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "seamless-image_svg__clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-1",
    d: "M235.1 266.27l-16.5-16.53 25.69-16.64 16.5 16.54-25.69 16.63z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "seamless-image_svg__clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-1",
    d: "M242.95 261.19l-19.91-7 13.4-16 19.91 7-13.4 16"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "seamless-image_svg__clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-1",
    d: "M237.05 259.25l-9.51-9.53 14.81-9.59 9.51 9.53-14.81 9.59z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "seamless-image_svg__clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-1",
    d: "M241.58 256.32l-11.48-4.04 7.72-9.22 11.48 4.04-7.72 9.22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "seamless-image_svg__clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-1",
    d: "M366.78 305.6l-3.35-23.5 8.96 5.26 3.36 23.5-8.97-5.26z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "seamless-image_svg__clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-1",
    d: "M370.12 301.33l-1.94-13.54 5.17 3.03 1.94 13.55-5.17-3.04z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "seamless-image_svg__linear-gradient",
    x1: 168.99,
    y1: 308.37,
    x2: 365.13,
    y2: 308.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#52c7ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "seamless-image_svg__linear-gradient-2",
    x1: 210.56,
    y1: 312.26,
    x2: 353.61,
    y2: 312.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#52c7ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "seamless-image_svg__linear-gradient-3",
    x1: 146.94,
    y1: 341.43,
    x2: 394.75,
    y2: 341.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#152935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52c7ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "seamless-image_svg__linear-gradient-4",
    x1: 174.05,
    y1: 313.5,
    x2: 477.47,
    y2: 313.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#52c7ea",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "seamless-image_svg__linear-gradient-5",
    x1: 181.96,
    y1: 323.48,
    x2: 378.11,
    y2: 323.48,
    xlinkHref: "#seamless-image_svg__linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "seamless-image_svg__linear-gradient-6",
    x1: 147.66,
    y1: 296.84,
    x2: 395.48,
    y2: 296.84,
    xlinkHref: "#seamless-image_svg__linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "seamless-image_svg__linear-gradient-7",
    x1: 180.4,
    y1: 316.97,
    x2: 323.5,
    y2: 316.97,
    xlinkHref: "#seamless-image_svg__linear-gradient-2"
  }), /*#__PURE__*/React.createElement("style", null, ".seamless-image_svg__cls-1{fill:none}.seamless-image_svg__cls-2,.seamless-image_svg__cls-29,.seamless-image_svg__cls-3,.seamless-image_svg__cls-30,.seamless-image_svg__cls-33{fill:#52c7ea}.seamless-image_svg__cls-2{opacity:.1}.seamless-image_svg__cls-6{opacity:.2}.seamless-image_svg__cls-5{fill:#0a1a2b}.seamless-image_svg__cls-6,.seamless-image_svg__cls-7{fill:#ec432d}.seamless-image_svg__cls-11{fill:#152935}.seamless-image_svg__cls-17,.seamless-image_svg__cls-30,.seamless-image_svg__cls-33{isolation:isolate}.seamless-image_svg__cls-16{opacity:.4}.seamless-image_svg__cls-26{fill:#171e23}.seamless-image_svg__cls-29,.seamless-image_svg__cls-33{opacity:.5}.seamless-image_svg__cls-30{opacity:.2}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-2",
    d: "M120 406.07c0 6.19-9.26 11.2-20.69 11.2s-20.69-5-20.69-11.2a7.06 7.06 0 011.64-4.37 40.38 40.38 0 0018.18 4 39.39 39.39 0 0019.35-4.66 7.27 7.27 0 012.21 5.03z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M98.45 406.09A41 41 0 0180.11 402c-6.33-3.25-10-8-10-13 0-9.41 12.7-17.07 28.31-17.07s28.3 7.66 28.3 17.07c0 4.74-3.11 9.13-8.77 12.36-5.23 3.05-12.17 4.73-19.5 4.73zm0-33.42c-15.2 0-27.57 7.33-27.57 16.34 0 4.75 3.48 9.25 9.56 12.37a40.36 40.36 0 0018 4c7.2 0 14-1.64 19.17-4.62C123 397.64 126 393.47 126 389c0-9-12.35-16.33-27.55-16.33z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.32,
    cy: 389.01,
    rx: 20.69,
    ry: 11.18,
    opacity: 0.2,
    fill: "#52c7ea"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-5",
    d: "M79.38 339.28a.75.75 0 00-.75.75v34.21c0 6.17 9.26 11.18 20.69 11.18s20.69-5 20.69-11.18V340a.75.75 0 00-.75-.75z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M119.26 340v34.21c0 5.76-9 10.45-20 10.45s-20-4.69-20-10.45v-34.23h39.88m0-.73H79.38a.75.75 0 00-.75.75v34.21c0 6.17 9.26 11.18 20.69 11.18s20.69-5 20.69-11.18V340a.75.75 0 00-.75-.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M99.32 330.41c11 0 20 4.69 20 10.45s-9 10.45-20 10.45-20-4.69-20-10.45 9-10.45 20-10.45m0-.73c-11.43 0-20.69 5-20.69 11.18S87.89 352 99.32 352 120 347 120 340.86s-9.26-11.18-20.69-11.18z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "seamless-image_svg__cls-5",
    cx: 99.32,
    cy: 340.51,
    rx: 20.69,
    ry: 11.18
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M99.32 330.06c11 0 20 4.69 20 10.45s-9 10.44-20 10.44-20-4.68-20-10.44 9-10.45 20-10.45m0-.74c-11.43 0-20.69 5-20.69 11.19s9.26 11.18 20.69 11.18 20.69-5 20.69-11.18-9.26-11.19-20.69-11.19z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-2",
    d: "M22.13 246.16l99.05-53.6a8.41 8.41 0 018.39.21l45.55 27.66a8.43 8.43 0 01-.23 14.55L79 289.07a8.44 8.44 0 01-8.37 0l-48.7-28.19a8.43 8.43 0 01.2-14.72z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "seamless-image_svg__cls-6",
    cx: 213.59,
    cy: 273.92,
    r: 10.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "seamless-image_svg__cls-7",
    cx: 213.59,
    cy: 273.92,
    r: 5.88
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M182 402.61c-27.84-29.42-9.4-92.23 41.1-140 24.43-23.13 52.65-39.34 79.45-45.65s49.11-1.94 62.62 12.34l-.53.5c-13.33-14.08-35.32-18.39-61.92-12.12s-54.77 22.42-79.12 45.46c-50.2 47.51-68.63 109.86-41.06 139z",
    fill: "url(#seamless-image_svg__linear-gradient)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M323.5 427.36l-.33-.66c35.86-18 39.84-82.85 8.89-144.65s-85.31-97.48-121.17-79.52l-.33-.65c36.22-18.15 91 17.67 122.15 79.84s27.01 127.5-9.21 145.64z",
    fill: "url(#seamless-image_svg__linear-gradient-2)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M303.3 388.93a228.57 228.57 0 01-45.37-4.71c-68.12-13.9-117.59-54.4-110.27-90.28l.72.14c-7.24 35.49 42 75.6 109.7 89.42s128.72-3.82 136-39.31l.71.14c-5.67 27.67-43.36 44.6-91.49 44.6z",
    fill: "url(#seamless-image_svg__linear-gradient-3)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-11",
    d: "M374.08 319.16c0 56-45.84 101.46-102.39 101.46S169.3 375.19 169.3 319.16 215.14 217.7 271.69 217.7s102.39 45.43 102.39 101.46z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M364.57 357.16c-6.84 3.37-18.82 2.84-14.89 11.87 3.32 16.84 15.55-6.6 14.89-11.87zm-161.2-4.92c8.93 8.2 2.92 22.56 3.73 31.95-.41 4.05 2.8 9.93 6.05 3.9-3-4.67 3.49.52 1.76-4.9 5-7.05 10.06-10.72 13.42-19.48 4.16-1 3.77-6.46 4.9-9.86 1.87-2.51 4.43-6 3.88-9.43-2.52-4.05-8.38-3.93-12.48-5.94-2.76-5.81-10.75-10.87-16.22-12.4-3.1-1.57-4.29 4.15-6.95 2.12-2.26.45-3.62.94-3.52-2.66.33-3.2-4-3.36-3-6.67-.53-2-3.48-1.68-4.08.28-7 .72-2.92-12.08 3-9.07 4.26-2.53 7 6.46 7.78 1.17-1.7-3.39 2.7-7.57 4.88-9.42-1.2-3.68 4.31-4.5 4.33-7.39 1-2.94 4.47-1.16 6.26-2.64-.35-3.16-.85-5.58 3.75-5.86 1.31.59-2.11 3.64 1.41 4.62 5.73 1.52-2.13-11-2.63-13.23-1.11-1.68-2.19-3.86-4.62-2.68-.66-3-3.88-4.57-6.9-5.09.41 2-2.25 15.43-4.25 11-1.42-3.15-7.36-2.43-7.15-7.21 1.62-4.87 13.39-8.9 9.91-13.5 1.63 0 7.39-.84 6.54 3-3.08 7.56-3.6 3.58 2.95 7.45 1.74.68 2.1-3.36 1.6-4.28 1.55.46 4.75-.9 2.69-3.23-3.66-.92-1.32-5.85-5.53-5.79-3.63-3.48-15.46-5.18-10.55 3.21-12.71-5.38-27.81 31.05-30.2 51.68 4.81 8.46 2.73-6.37 7 8.3 35.87 17.81 10.36 10.18 22.24 32.05zM214.93 293zm-6.72-41c4.24-.32 3.39-2.15 5.39-5.17 2.25-1.43 6.71-2.66 7.58-5.31 13.17-9.89-25.69 13.14-12.97 10.4zm71 121.12c8.2-8 12-20.1 13.12-31.44 1.29-2.72 12.43-13.81 5.24-14.73-5.24 4-14.86-23-6.27-7.35 1.76 10.58 17.66 3.44 14.26-4.71-2-.91-7.28-3.47-5.62-6 3.67 1.28 5.39 7.24 9.69 6.05 6.83-1.4 6.59 8.33 10.12 12.47 1.69 12.76 9.74-21.66 14.12-5.39 2.78 2.5 4.9 5.44 4.27 9.8 2.76 5.25 7.72 3.56 2.06-1.46-1.81-8 4.68 3.83 6.58-4.45.23-11.18 13.43-11.3 6.85-24.12 4.62-6.94 3.94 8.44 7.28-2.9 8.42-14.78-20.85-56.93-36.18-48.58-2.81.45-10.26 2.78-8.76 6.4-1.07-1.13-3.43 1.15-3.63-.15-1.92-1.32-4.47-.9-6.28 1.53-1.21 1.52-6.42 0-5.27 2.51.52.1-1.33-.09-2.35 0-3.1.75-5.05 2.82-7.42.39-1.5 2.67-1.28 3.17-4.26.47-5.33-2-8-6.35-13.39-2.4-3.67 4.59-11.53 9-10 15.48 3.47 5 1.14 6.83-3.74 9.6 1.94-3.24-2.42-7-2-9.64-4.41-2-1 6-1.89 7-.8 2.29-2.72 5.13 1.63 4.16 4.35 1-6.35.77.1 6.25 1.38 2.59-1.81 1.31-3.63 1.66-4.62 2.91-2 9.25 3.34 8.12 1.43-1.91 8.08-12.43 8.46-4.61 1.91 2.73 1.89-1.5 2.39-1.19 3.17 1.17 2.18 3 2.37 5.15 1.53-.45 2-3.72 3.07-3.95a11.87 11.87 0 00-2-3c-1.2-1.1 1.3.34 2.51 2.44 1.58 1.63.47 5 2.8 5.54 4.33 3.33 1-.31 1.43-2.88 1.57-3.53-2.41 4.17 6.92 4 2.89.25 1.14.21.19 3-4.17 0-10.9 1.82-14.85-.64-3.59-2.07-1.31-5.49-6.27-4.08-3.32 1.28-8.92.28-11.44 2.66-5.47 8.35-13.95 30 3.4 30.77 3.8-3.64 4.83.29 9.21-.17 3.85 8.83-.37 40.46 13.87 38.27zm81-44.18c3-.31 3.46-3 .95-4.67-1.86 1.29-3.86 2.92-.96 4.59zm-1.45 10.22c-.18-6.31-6.66 4.35-.35 3.21.51-.09-.69-3 .34-3.29zm-3.17-23c.35-.48-.49-2.76-.92-2.25s-.22 3.53.91 2.09zm2.65 4.89c.25-.59-.32-1.24-1.27-1.44-1.74.72-.28 5.07 1.26 1.32zm4.94 17.54c1.14.8 3.67.43 3.75-1.09-1.12-.85-3.86-.73-3.76.97zm-.61-34.72c-3.2 5.3 1.43 1.26 4.68.72 1.65-5.02-2-3.21-4.69-.84zm-26 29.87c-.15-.26-.18-.27.03-.12zm6.41 4.24c-1.63-1.59-4.05-5.49-6.39-4.23 2.95.01 5.79 11.34 6.41 4.11zm-19.61-7.95c-.17.35.26.88.77 1.3 2.72 2.59.79-4.4-.74-1.42zm-29.67 33.86c4.9 4.26 5.74-9.65 4.31-12.69-3.33 1.99-5.9 7.85-4.28 12.57zm-36.39-123.03c-11.52-1.09 2.12-3.78-11.27-4.54-8.42.9-14.13 3.4-22.83 5.46-3.05 2.9-2.25 4.45-6.6 5-.2 1.54 3.16 1 4.25 1.58-.08.4-4.45.54-2.13 2.44 9.16-.8 5 4.11 9.29 6.79-2.43 4.95 3.6 27 8.83 8.58 14.79-3.76 5.36-10.24 11.68-7.79 2.24-.2 1.95-3.1 3.35-6.15 0-3.79 2.27-2.84 1.17-5.68-.53-3.17 5.03-3.44 4.26-5.69zm12.8 1.27c-6.74.2-5.69 6.08-1.76 4.66.39 1.19-.37 3.75 2.31 4.43 1.44-1 1.33-4.35 4.3-2.63 3.25-3.59-4.02-3.44-4.85-6.46zm6.86 1.41c8.68-1.24-3.11-3.42-5-2 .03.32 3.61 1.8 5.03 2zm-25.29 37.14c-2 1.56 1.77 3.46 2.37 1.12-.58-2.12-.89-3.03-2.37-1.12zm4.11-15.79c-1.89-.58-7.7-1.94-6 .51-.99 3.6 7.21 4.36 6-.51zm45.64-12.34c11.62-6.09-7.15-3.1-6.06 4.15 5.63 7.3.9-2.92 6.06-4.15zm-3.77-9c1.16 1.14 1.8-.51 3.07-.35-.02-2.34-3.18-1.54-3.07.33zm22.56.43c0 .42 3.21.77 4.16.6 1.81-1.58-4.26-1.94-4.16-.58zm-117.5 23.82c-.63 4.22 2.92-1.12 4.29.47-1.17-.74-3.08-2.2-4.29-.47zm8.3 53.4c.28.66 2.8-.46 1.37-1-.39.01-1.39.73-1.39 1zm-6.3-2.31c4.34 5.29 7.29.53-.95-2.52-9.39-1.24-5.32 1.24.95 2.52zm-3 2.31c0 .26 1.43.1 1.77.1 1.09-.68-1.75-.72-1.73-.1zm1-7.29c-.66-.16-1 1.19-.21 1.2.3 0 .63-1.05.26-1.2zm3 .23c-.62-.68-1.34-.75-1.21.54.09.57 1.38-.27 1.26-.54zm2.15 3.29c1.36-.87-.53-1.3-1-2.06-1.49.44-.11 2.12 1.05 2.06zm159.55 22.23c-.91.08-4 .38-2.4 1.41 2.45 2.52 4.79-2.13 2.45-1.41z",
    style: {
      isolation: "isolate"
    },
    opacity: 0.3,
    fill: "url(#seamless-image_svg__linear-gradient-4)"
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M221.89 417.69c-16.27 0-30.26-4.86-39.93-15.08l.54-.5c27.56 29.12 90.83 14.17 141-33.34s68.63-109.86 41.07-139l.53-.5c27.84 29.42 9.41 92.23-41.09 140-32.94 31.22-71.54 48.42-102.12 48.42z",
    fill: "url(#seamless-image_svg__linear-gradient-5)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M394.75 344.33l-.72-.14c3.5-17.15-5.95-35.89-26.61-52.77s-50.24-29.95-83.09-36.65c-67.72-13.81-128.71 3.82-135.95 39.31l-.72-.14c7.32-35.89 68.7-53.78 136.82-39.89 33 6.72 62.58 19.79 83.4 36.8s30.43 36.06 26.87 53.48z",
    fill: "url(#seamless-image_svg__linear-gradient-6)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M302.88 432.07c-34.15 0-75.87-33.33-101.53-84.56-15.07-30.08-22.42-61.78-20.71-89.26s12.35-47.57 29.92-56.37l.33.65c-17.33 8.68-27.81 28.49-29.52 55.77S187 317.21 202 347.18c25.53 51 67 84.16 100.83 84.17a44.9 44.9 0 0020.33-4.65l.33.66a45.61 45.61 0 01-20.61 4.71z",
    fill: "url(#seamless-image_svg__linear-gradient-7)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "seamless-image_svg__cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#seamless-image_svg__clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-7",
    d: "M186.71 296.76c-5.94.95-10.89 7-11.06 13.41s4.52 10.9 10.45 9.94 10.89-7 11.05-13.41-4.51-10.9-10.44-9.94"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#seamless-image_svg__clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-7",
    d: "M186.58 301.71c-3.42.55-6.27 4-6.37 7.73s2.6 6.28 6 5.72 6.27-4 6.37-7.72-2.6-6.29-6-5.73"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "seamless-image_svg__cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#seamless-image_svg__clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#seamless-image_svg__clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-7",
    d: "M232.67 243.64a12.67 12.67 0 00-2.77 2.36l-.29.35c-3.53 4.38-2 9.43 3.39 11.34a16.49 16.49 0 0013.73-1.95 13.52 13.52 0 002.72-2.31l.41-.49c3.44-4.36 1.93-9.36-3.47-11.25a16.43 16.43 0 00-13.72 1.95"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#seamless-image_svg__clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#seamless-image_svg__clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-7",
    d: "M235.65 246.2a7.48 7.48 0 00-1.69 1.47c-2.13 2.54-1.29 5.51 1.88 6.63a9.52 9.52 0 007.91-1.12 7.51 7.51 0 001.69-1.47c2.09-2.5 1.32-5.4-1.7-6.57l-.38-.13a9.54 9.54 0 00-7.71 1.19"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "seamless-image_svg__cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#seamless-image_svg__clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-7",
    d: "M367.91 284.73c-2.47-1.45-3.73 2.63-2.8 9.12s3.68 12.92 6.16 14.38 3.73-2.63 2.8-9.12-3.68-12.93-6.16-14.38"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#seamless-image_svg__clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-7",
    d: "M370.77 289.31c-1.43-.84-2.15 1.51-1.62 5.25s2.13 7.45 3.55 8.29 2.15-1.51 1.62-5.25-2.12-7.45-3.55-8.29"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "seamless-image_svg__laptop_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-11",
    d: "M124.49 150.43l-7.82-79.21 1.11-.45-1.55-.93a1.15 1.15 0 00-1.25.09L4 131.54a3.28 3.28 0 00-1.57 2.72l7.87 79.84a.9.9 0 00.51.81l1.51.92.38-1.48h-.1l110.35-61.24a3.26 3.26 0 001.54-2.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-26",
    d: "M124.52 154.1l-111 61.61c-.86.48-1.54.2-1.63-.65L4 135.22a3.25 3.25 0 011.57-2.71l111-61.61c.86-.48 1.54-.2 1.63.65l7.87 79.84a3.25 3.25 0 01-1.55 2.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b2126",
    d: "M114.84 75.99L7.83 135.38l7.49 75.2 106.94-59.35-7.42-75.24z",
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-5",
    d: "M189 191.91l-6 3-56-33.72a4.28 4.28 0 00-3.82.16l-104.9 58.19c-.93-.54-5.18-2.65-5.18-2.65l1.75 5.55a1.15 1.15 0 00.55.67l59 35.5a4.24 4.24 0 003.83-.16l107.22-59.5a2.05 2.05 0 00.93-.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-11",
    d: "M188 192.86l-109.88 61a4.39 4.39 0 01-3.92.16l-60.51-36.4c-1-.58-.76-1.59.44-2.26l109.89-61a4.36 4.36 0 013.92-.16l60.48 36.39c.96.6.77 1.61-.42 2.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-11",
    d: "M30.36 214.21l91.32-50.68a1.9 1.9 0 011.89 0l30 18.09a.67.67 0 01-.08 1.16l-91.28 50.66a1.93 1.93 0 01-1.89 0l-30-18.06a.68.68 0 01.04-1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M30.28 215.38l.3.18 91-50.5a1.9 1.9 0 011.89 0L153.15 183l.33-.19a.67.67 0 00.08-1.16l-30-18.09a1.9 1.9 0 00-1.89 0l-91.31 50.65a.68.68 0 00-.08 1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-26",
    d: "M125.61 168.11l-79.32 44.02-3.26-1.95 79.33-44.02 3.25 1.95zM133.59 172.91l-74.4 41.29-3.26-1.96 74.4-41.28 3.26 1.95zM138.78 176.04l-87.6 48.61-3.25-1.96 87.6-48.61 3.25 1.96zM143.97 179.16l-87.59 48.62-3.26-1.96 87.6-48.61 3.25 1.95zM149.17 182.29l-87.6 48.61-3.25-1.96 87.6-48.61 3.25 1.96zM41.49 214.79l-3.52 1.96-3.25-1.96 3.52-1.95 3.25 1.95zM53.26 217.49l-7.32 4.06-3.25-1.96 7.32-4.06 3.25 1.96zM120.66 226.47l24.62-13.66c1-.54 1-1.4.14-1.94l-15.53-9.34a3.73 3.73 0 00-3.35 0l-24.63 13.66c-1 .54-1 1.4-.13 1.94l15.53 9.34a3.67 3.67 0 003.35 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-5",
    d: "M124.42 153.85l-111 61.61c-.86.48-1.55.2-1.63-.65L3.89 135a3.29 3.29 0 011.58-2.71l111-61.61c.85-.47 1.54-.2 1.63.66l7.9 79.8a3.25 3.25 0 01-1.58 2.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-11",
    d: "M114.74 75.74L7.72 135.13l7.5 75.19 106.94-59.34-7.42-75.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M43.2 181.66l8.66-4.82.14 1.45-8.66 4.81-.14-1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-7",
    d: "M53.25 176.08l4.72-2.62.14 1.44-4.72 2.62-.14-1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M65.31 169.38l3.41-1.89.14 1.44-3.41 1.9-.14-1.45zM62.82 170.77l1.17-.65.14 1.44-1.17.65-.14-1.44zM59.38 172.68l2.12-1.18.14 1.45-2.12 1.17-.14-1.44zM50.56 170.6l3.41-1.89.15 1.44-3.42 1.9-.14-1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-7",
    d: "M42.55 175.05l6.69-3.71.14 1.44-6.69 3.72-.14-1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M53.4 151.63l6.69-3.71.14 1.44-6.69 3.72-.14-1.45zM49.96 153.54l2.12-1.17.14 1.44-2.12 1.18-.14-1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-7",
    d: "M54.01 158.24l6.69-3.71.14 1.44-6.68 3.72-.15-1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M50.57 160.16l2.12-1.18.14 1.44-2.12 1.18-.14-1.44zM50.65 123.1l-12.6 7-.14-1.44 12.6-7 .14 1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-7",
    d: "M55.09 120.64l-3.12 1.73-.14-1.45 3.12-1.73.14 1.45zM76.47 119.23l-12.6 7-.14-1.44 12.6-7 .14 1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M80.91 116.77l-3.12 1.73-.14-1.45 3.12-1.73.14 1.45zM41.79 131.51l-3.41 1.89-.14-1.44 3.41-1.9.14 1.45zM62.05 127.22l-3.41 1.9-.14-1.44 3.41-1.9.14 1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-7",
    d: "M49.8 127.06l-6.68 3.71-.15-1.44 6.69-3.72.14 1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M53.24 125.14l-2.11 1.18-.15-1.44 2.12-1.18.14 1.44zM61.32 120.67l-6.69 3.71-.15-1.44 6.69-3.72.15 1.45zM64.76 118.76l-2.12 1.17-.14-1.44 2.11-1.18.15 1.45zM61.73 123.92l-3.42 1.9-.14-1.45 3.41-1.89.15 1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-7",
    d: "M69.74 119.47l-6.69 3.72-.14-1.45 6.68-3.71.15 1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M73.18 117.56l-2.12 1.18-.14-1.45 2.11-1.17.15 1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-7",
    d: "M45.69 132.82l-6.98 3.88-.15-1.44 6.99-3.88.14 1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M52.06 129.28l-5.05 2.81-.14-1.45 5.05-2.8.14 1.44zM56.8 126.65l-3.41 1.9-.15-1.45 3.42-1.89.14 1.44zM89.65 111.93l-6.99 3.88-.14-1.45 6.98-3.88.15 1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-7",
    d: "M96.02 108.39l-5.05 2.8-.14-1.44 5.05-2.81.14 1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M100.76 105.75l-3.42 1.9-.14-1.44 3.41-1.9.15 1.44zM83.98 155.54l6.98-3.88.14 1.45-6.98 3.88-.14-1.45zM77.6 159.08l5.05-2.8.15 1.44-5.05 2.81-.15-1.45zM72.87 161.71l3.41-1.89.14 1.44-3.41 1.9-.14-1.45zM81.4 160.47l6.99-3.88.14 1.44-6.98 3.88-.15-1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-7",
    d: "M75.03 164.01l5.05-2.81.14 1.45-5.05 2.8-.14-1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M70.29 166.64l3.42-1.9.14 1.45-3.41 1.89-.15-1.44zM54.73 154.36l2.36-1.31.14 1.45-2.36 1.31-.14-1.45zM50.29 156.83l3.11-1.73.15 1.44-3.12 1.73-.14-1.44zM46.06 136.1l-6.98 3.89-.14-1.45 6.98-3.88.14 1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-7",
    d: "M52.44 132.56l-5.06 2.81-.14-1.44 5.05-2.81.15 1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M57.17 129.93l-3.41 1.9-.14-1.45 3.41-1.89.14 1.44zM41.76 141.97l-2.36 1.32-.14-1.45 2.36-1.31.14 1.44zM46.2 139.51l-3.11 1.73-.15-1.45 3.12-1.73.14 1.45zM52.55 135.98l-5.02 2.79-.15-1.44 5.03-2.79.14 1.44zM57.17 163.46l2.36-1.31.15 1.45-2.36 1.31-.15-1.45zM52.73 165.93l3.12-1.73.14 1.44-3.11 1.74-.15-1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-7",
    d: "M46.39 169.46l5.02-2.8.14 1.45-5.02 2.79-.14-1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M61 158.1l5.02-2.79.15 1.45-5.02 2.79-.15-1.45zM52.8 162.41l6.78-3.76.14 1.44-6.77 3.76-.15-1.44zM49.36 164.32l2.12-1.18.15 1.45-2.12 1.18-.15-1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-7",
    d: "M46.06 166.16l2.12-1.18.14 1.44-2.12 1.18-.14-1.44zM47.8 147.5l6.69-3.71.14 1.44-6.68 3.72-.15-1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M44.36 149.41l2.12-1.17.14 1.44-2.12 1.18-.14-1.45zM48.52 143.62l2.35-1.31.15 1.45-2.36 1.31-.14-1.45zM56.34 146.27l2.35-1.31.15 1.44-2.36 1.31-.14-1.44zM59.7 144.4l5.66-3.14.14 1.44-5.66 3.14-.14-1.44zM66.36 140.7l3.37-1.87.14 1.45-3.37 1.87-.14-1.45zM44.08 146.09l3.11-1.73.15 1.44-3.12 1.73-.14-1.44zM44.03 142.7l2.36-1.31.14 1.44-2.36 1.31-.14-1.44zM39.59 145.16l3.12-1.73.14 1.45-3.12 1.73-.14-1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-7",
    d: "M52.91 148.16l2.12-1.17.14 1.44-2.12 1.18-.14-1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M49.61 150l2.12-1.18.14 1.45-2.12 1.17-.14-1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-7",
    d: "M64.09 166.59l7.22-4.01.15 1.44-7.23 4.01-.14-1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M56 171.09l6.77-3.77.14 1.45-6.77 3.76-.14-1.44zM52.55 173l2.12-1.18.15 1.44-2.12 1.18-.15-1.44zM49.25 174.83l2.12-1.18.14 1.45-2.11 1.18-.15-1.45zM47.45 175.83l-4.57 2.54.14 1.45 4.57-2.54-.14-1.45z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-29",
    d: "M90.09 203.8c-9.36 0-17-3.89-17-8.68s7.62-8.67 17-8.67 17 3.89 17 8.67-7.63 8.68-17 8.68zm0-16.62c-9 0-16.25 3.57-16.25 7.94s7.29 7.95 16.25 7.95 16.26-3.57 16.26-7.95-7.29-7.94-16.26-7.94z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "seamless-image_svg__cls-30",
    cx: 89.54,
    cy: 195.12,
    rx: 9.97,
    ry: 4.99
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M239.7 246.67h-.1a.35.35 0 01-.25-.45c7.59-26.36 3.57-51.65-11.34-71.19C213.35 155.79 189.64 144 166 144h-1c-29.77.38-64.55 16.56-75.14 51.82a.36.36 0 01-.45.25.36.36 0 01-.25-.46c4.08-13.6 12.93-26.2 24.91-35.48 13.93-10.82 31.56-16.66 50.93-16.91 24.22-.3 48.58 11.7 63.57 31.34s19.12 45.25 11.46 71.84a.37.37 0 01-.33.27zM288.77 297.34a.37.37 0 01-.36-.33 350.26 350.26 0 010-61.38c2.71-31.45 11.12-75.47 35.76-106.59 14.19-17.92 28-26.13 40.89-24.38 19.63 2.65 30.5 27.71 30.6 28a.36.36 0 11-.67.28c-.11-.25-10.81-24.94-30-27.52-12.67-1.7-26.2 6.4-40.22 24.1-24.52 31-32.89 74.85-35.6 106.19a349.94 349.94 0 000 61.25.38.38 0 01-.33.41z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "seamless-image_svg__Path",
    className: "seamless-image_svg__cls-30",
    d: "M457.61 413.32l-24.37-14.39 24.37-14.41 24.38 14.41-24.38 14.39z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M458.16 438.06c-17.07 0-33.12-3.79-45.17-10.69s-18.89-16.3-18.89-26.23 6.71-19.26 18.89-26.23c24.91-14.26 65.45-14.26 90.36 0 12.18 7 18.89 16.28 18.89 26.23s-6.71 19.25-18.89 26.23-28.1 10.69-45.19 10.69zm0-73.12c-16.23 0-32.46 3.53-44.81 10.61-11.95 6.83-18.53 15.92-18.53 25.59s6.58 18.75 18.53 25.6 27.85 10.59 44.8 10.59S491 433.57 503 426.74s18.52-15.94 18.52-25.6-6.58-18.76-18.52-25.59c-12.37-7.08-28.6-10.61-44.83-10.61z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M458.16 448c-21.52 0-41.73-4.84-56.91-13.63s-23.77-20.66-23.77-33.27 8.44-24.43 23.77-33.28c31.38-18.15 82.45-18.16 113.85 0 15.32 8.85 23.76 20.67 23.76 33.28s-8.32 24.26-23.44 33.08l-.23.13-.08.05-.12.07-.19.11c-15.16 8.72-35.25 13.46-56.64 13.46zm0-93.07c-20.49 0-41 4.51-56.56 13.53-15.08 8.71-23.39 20.3-23.39 32.64s8.31 23.92 23.39 32.64 35.16 13.52 56.55 13.52 41.5-4.8 56.57-13.52l.06.1-.06-.1c15.09-8.72 23.4-20.31 23.4-32.64s-8.31-23.93-23.4-32.64c-15.59-8.98-36.07-13.46-56.55-13.46z",
    style: {
      isolation: "isolate"
    },
    opacity: 0.6,
    fill: "#52c7ea"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M457.63 430.31c-13.38 0-25.95-3-35.39-8.43S407.4 409 407.4 401.14s5.27-15.23 14.84-20.74c19.51-11.24 51.25-11.24 70.76 0 9.57 5.51 14.84 12.88 14.84 20.74s-5.27 15.22-14.84 20.74-22 8.43-35.37 8.43zm0-57.62c-12.68 0-25.36 2.78-35 8.34-9.33 5.38-14.47 12.52-14.47 20.11s5.14 14.72 14.47 20.1 21.77 8.34 35 8.34 25.67-3 35-8.34 14.48-12.52 14.48-20.1S502 386.41 492.63 381c-9.63-5.52-22.33-8.31-35.01-8.31z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "seamless-image_svg__Path-2",
    "data-name": "Path",
    fill: "#fff",
    d: "M454.86 373.99l-2.85-28.25-23.2 16.57 2.84 28.25 26.03 11.69 23.2-16.57-26.02-11.69z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M457.69 402.36l-26.13-11.73v-.06l-2.85-28.31h.05l23.34-16.66v.16l2.84 28.2 26.13 11.73-.14.1zm-25.95-11.87l25.93 11.64 23-16.43-25.93-11.64V374l-2.83-28.08-23 16.43z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "seamless-image_svg__Path-3",
    "data-name": "Path",
    className: "seamless-image_svg__cls-5",
    d: "M431.65 390.56l-2.84-28.25 23.26-16.57 2.79 28.25-23.21 16.57z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M431.65 390.93a.28.28 0 01-.15 0 .34.34 0 01-.21-.29l-2.84-28.26a.34.34 0 01.15-.33l23.26-16.57a.38.38 0 01.36 0 .35.35 0 01.21.3l2.79 28.22a.35.35 0 01-.15.33l-23.2 16.57a.44.44 0 01-.22.03zm-2.45-28.45l2.8 27.41 22.51-16.07-2.7-27.41z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "seamless-image_svg__Path-4",
    "data-name": "Path",
    className: "seamless-image_svg__cls-5",
    d: "M457.68 402.25l-26.03-11.69 23.33-16.64 25.9 11.76-23.2 16.57z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M457.68 402.73a.45.45 0 01-.2 0l-26-11.68a.5.5 0 01-.08-.85l23.33-16.64a.46.46 0 01.48 0l25.91 11.75a.53.53 0 01.28.4.49.49 0 01-.2.45L458 402.64a.47.47 0 01-.32.09zm-25.05-12.27l25 11.22 22.29-15.91L455 374.48z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "seamless-image_svg__Path-5",
    "data-name": "Path",
    className: "seamless-image_svg__cls-5",
    d: "M454.91 373.96l-2.83-28.22 25.98 11.67 2.82 28.22-25.97-11.67z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M480.88 386a.4.4 0 01-.15 0l-26-11.67a.35.35 0 01-.21-.3l-2.84-28.21a.4.4 0 01.15-.34.38.38 0 01.37 0l26 11.67a.37.37 0 01.21.3l2.82 28.21a.4.4 0 01-.15.34.43.43 0 01-.2 0zm-25.62-12.28l25.2 11.28-2.74-27.37-25.21-11.32z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "seamless-image_svg__Path-6",
    "data-name": "Path",
    className: "seamless-image_svg__cls-33",
    d: "M497.5 415.54a3.33 3.33 0 103.33-3.32 3.32 3.32 0 00-3.33 3.32z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "seamless-image_svg__Oval",
    className: "seamless-image_svg__cls-3",
    cx: 500.83,
    cy: 415.54,
    r: 1.66
  })), /*#__PURE__*/React.createElement("circle", {
    id: "seamless-image_svg__Oval-2",
    "data-name": "Oval",
    cx: 437.12,
    cy: 427.17,
    r: 4.99,
    style: {
      isolation: "isolate"
    },
    opacity: 0.5,
    fill: "#ec432d"
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "seamless-image_svg__Path-7",
    "data-name": "Path",
    className: "seamless-image_svg__cls-7",
    d: "M434.91 427.36a2.22 2.22 0 004.42 0 2.22 2.22 0 10-4.42 0z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "seamless-image_svg__Path-8",
    "data-name": "Path",
    className: "seamless-image_svg__cls-33",
    d: "M416.63 382.3A3.32 3.32 0 10420 379a3.32 3.32 0 00-3.32 3.32z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "seamless-image_svg__Path-9",
    "data-name": "Path",
    className: "seamless-image_svg__cls-3",
    d: "M418.29 382.3a1.66 1.66 0 101.66-1.66 1.66 1.66 0 00-1.66 1.66z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M383.85 428.14h-1.3c-35.78-.64-71.15-26.49-105.12-76.84a.37.37 0 01.09-.51.36.36 0 01.51.1c33.84 50.14 69 75.89 104.53 76.51h1.29c43.46 0 72.08-38.64 72.36-39a.37.37 0 01.6.43c-.29.37-29.13 39.31-72.96 39.31z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "seamless-image_svg__cls-6",
    cx: 277.19,
    cy: 349.56,
    rx: 9.99,
    ry: 8.86,
    transform: "rotate(-6.02 277.388 349.745)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "seamless-image_svg__cls-7",
    cx: 277.19,
    cy: 349.56,
    rx: 5.76,
    ry: 5.11,
    transform: "rotate(-6.02 277.388 349.745)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-29",
    d: "M457.48 396.21a11.3 11.3 0 01-4.59-1 10.69 10.69 0 01-5.16-4.7 6.55 6.55 0 014.39-9.78 11.19 11.19 0 0112.1 5.43 6.53 6.53 0 01-4.39 9.77 9.12 9.12 0 01-2.35.28zm-3-15a8.72 8.72 0 00-2.17.27 5.81 5.81 0 00-3.92 8.72 10.44 10.44 0 0011.27 5 5.8 5.8 0 003.91-8.72 9.88 9.88 0 00-4.8-4.37 10.5 10.5 0 00-4.3-.94z"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "seamless-image_svg__cls-30",
    cx: 455.88,
    cy: 388.54,
    rx: 4.3,
    ry: 5.43,
    transform: "rotate(-65.86 455.846 388.538)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M99.32 339.65a.36.36 0 01-.35-.27c0-.13-3.61-12.79 5.25-23.84 10.45-13 33-18.45 67-16.15a.37.37 0 01.34.39.36.36 0 01-.39.34c-33.73-2.27-56.06 3.07-66.35 15.87-8.63 10.74-5.16 23.06-5.13 23.19a.36.36 0 01-.25.45z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "seamless-image_svg__cls-6",
    cx: 288.68,
    cy: 295.82,
    r: 9.99
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "seamless-image_svg__cls-7",
    cx: 288.68,
    cy: 295.82,
    r: 5.76
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M142.72 159.45l-.01-.98h.01v.98z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-2",
    d: "M493.91 215.25c0-10.92-7.67-24.2-17.13-29.66a16.22 16.22 0 00-6.89-2.31v-.53c0-8.54-6-18.92-13.39-23.19a12.39 12.39 0 00-5.71-1.81c-5.22-13.63-15.1-26.5-26.43-33-7.42-4.28-14.21-5.13-19.48-3.08l-3.88 2.19a18.07 18.07 0 00-5.72 8.91 36.89 36.89 0 00-9.06-7.64c-5-2.89-9.6-3.48-13.17-2.13l-2.81 1.63-19.58 18.16 56.59 54.29 63.24 46.56 19.67-18.24c2.35-2.04 3.75-5.5 3.75-10.15z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-11",
    d: "M457.2 203.75a16.26 16.26 0 00-6.9-2.31v-.53c0-8.54-6-18.92-13.39-23.19a12.39 12.39 0 00-5.71-1.81c-5.22-13.63-15.1-26.5-26.43-33-7.42-4.28-14.21-5.13-19.48-3.08l-3.84 2.17a18.15 18.15 0 00-5.73 8.91 36.66 36.66 0 00-9.05-7.64c-5-2.89-9.6-3.48-13.17-2.13l-2.81 1.63c-2.93 2.43-4.7 6.68-4.7 12.44 0 1 .06 1.91.15 2.89 1.21 12.56 9.93 26.8 20.53 32.91l79.05 45.65 11.48 6.62c9.46 5.46 17.12 1 17.12-9.89s-7.66-24.18-17.12-29.64z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-3",
    d: "M464.85 246a16 16 0 01-7.84-2.39l-90.53-52.27c-10.57-6.1-19.48-20.38-20.7-33.19-.1-1-.15-2-.15-2.93 0-5.63 1.71-10.15 4.83-12.72l2.85-1.67c3.86-1.46 8.64-.69 13.54 2.13a36.37 36.37 0 018.72 7.24 18.14 18.14 0 015.65-8.48l3.91-2.26c5.61-2.19 12.64-1.09 19.85 3.08 10.92 6.3 21.06 18.93 26.51 33a12.76 12.76 0 015.63 1.84c7.48 4.32 13.57 14.87 13.57 23.51v.2a16.86 16.86 0 016.69 2.32c9.55 5.51 17.31 19 17.31 30 0 5.42-1.85 9.47-5.2 11.41a9.14 9.14 0 01-4.64 1.18zM357.41 140.84a10.65 10.65 0 00-3.78.66l-2.76 1.61c-2.89 2.4-4.51 6.71-4.51 12.12 0 .89.05 1.85.15 2.86 1.2 12.6 9.95 26.63 20.34 32.63L457.38 243c4.46 2.58 8.63 3 11.75 1.2s4.83-5.62 4.83-10.77c0-10.78-7.6-23.95-16.95-29.34a15.61 15.61 0 00-6.73-2.26.37.37 0 01-.34-.38v-.23-.29c0-8.41-5.92-18.67-13.21-22.88a11.94 11.94 0 00-5.53-1.75.37.37 0 01-.33-.24c-5.37-14-15.44-26.6-26.28-32.86-7-4.05-13.81-5.13-19.16-3.06l-3.82 2.21a17.8 17.8 0 00-5.56 8.71.36.36 0 01-.27.25.38.38 0 01-.35-.12 36.14 36.14 0 00-9-7.56 18.51 18.51 0 00-9.02-2.79z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "seamless-image_svg__cls-1",
    d: "M1.19.7h540v540h-540z"
  })));
}

export default __webpack_public_path__ + "static/seamless-image.74bc05d8.svg";
export { SvgSeamlessImage as ReactComponent };